import axios from "../plugins/axios";
import AdminServicesAxios from "../plugins/axios-admin-services";
import helper from "../utils/helper";

let postPromise = function(url, data) { 
  return new Promise(function (resolver, reject) { 
    axios.post(url, data).then(res => {
      if (typeof (res) != "undefined")
        resolver(res.data);
      else
        reject({"error":"error"});
    }).catch(error => {
      reject(error);
    });
  })
}
let getPromise = function(url) { 
  return new Promise(function (resolver, reject) { 
    axios.get(url).then(res => {
      if (typeof (res) != "undefined")
        resolver(res.data);
      else
        reject({"error":"error"});
      }).catch(error => {
        reject(error);
    });
  })
}

let postASPromise = function(url, data) { 
  return new Promise(function (resolver, reject) { 
    AdminServicesAxios.post(url, data).then(res => {
      if (typeof (res) != "undefined")
        resolver(res.data);
      else
        reject({"error":"error"});
    }).catch(error => {
      reject(error);
    });
  })
}
let getASPromise = function(url) { 
  return new Promise(function (resolver, reject) { 
    AdminServicesAxios.get(url).then(res => {
      if (typeof (res) != "undefined")
        resolver(res.data);
      else
        reject({"error":"error"});
      }).catch(error => {
        reject(error);
    });
  })
}
let WIOM_APIS = {
  fetchUser: () => {
    if(window.viewBag && window.viewBag.user) {
      return new Promise(function (resolver) { 
        resolver(window.viewBag.user);
      });
    }

    return new Promise(function (resolver) { 
      getASPromise('/v1/Authentication/FetchUser').then(response => {
        if (response.status == 0) {
          let userData = response.data.user;
          userData.username = response.data.username;
          helper.setCookie("userData", JSON.stringify(userData), 7);
          helper.setCookie("loggedIn", true, 7);
          window.viewBag = window.viewBag || {};
          window.viewBag.user = userData;
          resolver(userData);
        } else {
          window.location.href = `${window.location.origin}/#/auth/verify-pass`;
        }
        console.log('fetchUser response', response, '/auth/verify-pass')
      });
    })
  },
  getLocations: (userid) => {
    return new Promise(function(resolver) {
      getPromise("/Client/GetLocationsForAdmin?source=wiom&" +
      "pageNumber=1&pageSize=500&userid=" + userid).then(res => { 
        let set = new Set();
        let arr = []
        if (res.data) {
          res.data.forEach(ele => {
            if (!set.has(ele.nasid)) {
              arr.push(ele);
              set.add(ele.nasid);
            }
            ele.subscription.startDate = new Date(ele.subscription.start);
            ele.subscription.endDate = new Date(ele.subscription.end);
          });
          res.data = arr;
        }
        resolver(arr)
      })
    })
  },
  savePlans: (nasid, plans) => {
    return postPromise("/WiomDashboard/UpdatePlans", {
      nasid: nasid,
      plans: plans
    });
  },
  getPlans: (nasid) => {
    if(!nasid) return null;
    return getPromise("/wiom/GetPlans?nasid=" + nasid);
  },
  getPaymentModes: (nasid) => { 
    return new Promise(function (resolver) { 
      getPromise("/wiom/GetSingleNasOperation?nasid=" + nasid + "&operationId=21").then((response) => { 
        let obj = {
          cash: true
        }
        if (response.data && response.data != "") {
          let spl = response.data.split(';')
          spl.forEach(s => {
            obj[s.substring(0, s.indexOf(':'))] = s.substring(s.indexOf(':') + 1);
          })
        }
        console.log('fetched payment data:', obj)
        resolver(obj);
      })
    })
  },
  savePaymentModes: (nasid, value) => {
    return postPromise("/wiom/SaveSingleNasOperation", {
      nasid: nasid,
      value: value,
      operationId: 21
    })
  },
  uploadFile: (content) => {
    return new Promise(function (resolver) { 
      axios({
        method: "POST",
        url:"/Client/UploadFile",
        data: content,
        headers: {
          "Content-Type": "multipart/form-data; boundary=${form._boundary}"
        }
      }).then(response => {
        resolver(response.data.msg);
      });
    })
  },
  setUserBasicConfig: (data) => {
    return postASPromise("/v1/Setting/SetUserGroupBasicConfiguration", data);
  },
  setAdvanceConfiguration: (data) => {
    return postPromise ("/WiomDashboard/SetAdvanceConfiguration", data);
  },

  toSpreadSheet: (data) => {
    data.action = 'post'
    console.log('adding record to google sheet')
    let getParams = "";
    Object.keys(data).forEach(key => {
      getParams += `&${key}=${data[key]}`;
    })
    getParams = getParams.substring(1);
    let script_url = "https://script.google.com/macros/s/AKfycbyihJ1dt0qwzKpW3pP2iJCEC_sOQM0cnFI0ZatWim6RFktdjNUjnlOQnA/exec";
    let url = script_url + "?" + getParams;
    fetch(url);
  },
  searchSpreadSheet: (data) => {
    console.log('getting data from google sheet')
    data.action = 'search';
    let getParams = "";
    Object.keys(data).forEach(key => {
      getParams += `&${key}=${data[key]}`;
    })
    getParams = getParams.substring(1);
    let script_url = "https://script.google.com/macros/s/AKfycbyihJ1dt0qwzKpW3pP2iJCEC_sOQM0cnFI0ZatWim6RFktdjNUjnlOQnA/exec";
    let url = script_url + "?" + getParams;
    return new Promise(function (resolver) { 
      fetch(url).then(res => { 
        resolver(res.json())
      })
    });
  },
  getUserBasicConfig: (settingId) => {
    return getPromise(`/Client/GetUserGroupBasicConfiguration?settingId=${settingId}&groupId=0`);
  },
  getAdvanceConfiguration: (settingId) => {
    return getPromise("/Client/GetAdvanceConfiguration?version=0&settingId=" + settingId);
  },
  upgradeUserPolicy: (nasid, fdmId, planId) => {
    return postASPromise("/v1/FDM/UpgradeUserPolicy", {
      nasid: nasid,
      fdmId: fdmId,
      planId: planId
    })
  },
  authorizeUser: (mobile, nasid, allow = true) => {
    return postASPromise("/v1/FDM/AuthorizeUser", {
      nasid: nasid,
      mobile: mobile,
      allow: allow
    });
  },
  updateUser: (user) => {
    return postASPromise("/v1/FDM/UpdateUser", user);
  },
  createUser: (voucher) => {
    return postASPromise("/v1/FDM/CreateUser", voucher)
  },
  getUsers: (options) => {
    return postASPromise("/v1/FDM/GetUsers", options)
  },
  logoutUser: (mobile, nasid) => {
    return postASPromise("/v1/FDM/LogoutUser",
    {
      nasid: nasid,
      mobile: mobile
    });
  },
  logout: () => {
    let iframe = document.createElement('iframe');
    iframe.src = 'http://localhost:5001/auth/logout';
    if (process.env.NODE_ENV != 'prod') {
      iframe.src = 'https://services.testease.i2e1.in/auth/logout';
    }
    document.body.append(iframe);
    return getASPromise('/auth/logout');
  }
};

export default WIOM_APIS; 
